import { LoadstarModel } from '../../../src/models/loadstar-model'
import { ScheduleChangeModel } from '../../../src/models/schedule-change-model'
import { ScheduleChangeEvents } from '../../../src/models/schedule-change-model-impl'
import { VesselAlarmsModel } from '../../../src/models/vessel-alarms-model'
import { VesselAlertsModel } from '../../../src/models/vessel-alerts-model'
import { VesselPlanningModel } from '../../../src/models/vessel-planning-model'
import { VoyageWeatherRoutingModel } from '../../../src/models/weather-routing-model'
import { ACCEPT_SHOW_PLAN } from '../../../src/models/weather-routing-model-impl'
import { WeatherRoutingModel } from '../../../src/models/weather-routing-reports-model'
import { SHOW_WNI_REPORT_POPUP } from '../../../src/models/weather-routing-reports-model-impl'

// For weather routing
// import { VoyageWeatherRoutingModel } from '../../../src/models/weather-routing-model'
// import { ACCEPT_SHOW_PLAN } from '../../../src/models/weather-routing-model-impl'
// import { WeatherRoutingModel } from '../../../src/models/weather-routing-reports-model'
// import { SHOW_WNI_REPORT_POPUP } from '../../../src/models/weather-routing-reports-model-impl'
import {
    NotificationTypes,
    VoyNotification,
} from '../../../src/services/types/vessel-notifications-services.types'
import { VoyageDialogPopupManager } from '../../voyage-dialog-popup/src/voyage-dialog-popup-manager'

// action for AlarmType.SubmittedAlarm
export function openLog() {
    VesselAlarmsModel?.openLog()
}

// action for AlarmType.AlarmReminder
export function stateReason(alarmId: string | number) {
    let alarmData = JSON.parse(localStorage.getItem('doItLaterAlarm') || '[]')
    if (alarmData.length) {
        let alarm: VoyNotification<NotificationTypes.Alarm>[] =
            alarmData.filter(
                (val: VoyNotification<NotificationTypes.Alarm>) => {
                    return val.id == alarmId
                },
            )
        VesselAlarmsModel?.stateReason(alarm[0])
    }
}

//

// action for AlarmType.WeatherRoutingAdviceAvailable
export function viewAdvice(id: string) {
    const SnoozedWr = JSON.parse(localStorage.getItem('SnoozedWr') || '{}')
    if (SnoozedWr) {
        VesselPlanningModel!.dispatchEvent(
            new CustomEvent('view-wni-advice-clicked-from-notification', {
                detail: {
                    wrId: SnoozedWr.id,
                    scheduleId: SnoozedWr.scheduleId,
                },
            }),
        )
    }
    VesselAlertsModel?.removeAlert((<any>window)['appenv'].vesselIMONumber, id)
}

// action for AlertType.EtaChangeRemindLater:
export function reviewChange() {
    ScheduleChangeModel!.dispatchEvent(
        new CustomEvent(ScheduleChangeEvents.ReviewChange, {
            bubbles: true,
            composed: true,
        }),
    )
}

export function reviewLoadstarChanges(alertId: string) {
    LoadstarModel?.openReviewChanges(alertId)
}

/** WEATHER ROUTING */

// action for
// - AlarmType.WeatherRoutingAdviceActionNeeded
// - AlarmType.CounterProposalNotification
export function showPlan({
    id,
    scheduleId,
}: {
    id: string
    scheduleId?: string
}) {
    VoyageWeatherRoutingModel!.dispatchEvent(
        new CustomEvent(ACCEPT_SHOW_PLAN, {
            detail: { scheduleId },
        }),
    )
    VesselAlertsModel?.removeAlert((<any>window)['appenv'].vesselIMONumber, id)
}

// action for AlarmType.WNIReports
export function viewReport({
    id,
    reportType,
    scheduleId,
    reportId,
}: {
    id: string
    reportType?: string
    scheduleId?: string
    reportId?: number
}) {
    WeatherRoutingModel!.dispatchEvent(
        new CustomEvent(SHOW_WNI_REPORT_POPUP, {
            detail: {
                minimizedPopUp: true,
                reportType,
                scheduleId,
                reportId,
                fromNotification: true,
            },
        }),
    )
    VesselAlertsModel?.removeAlert((<any>window)['appenv'].vesselIMONumber, id)
}

// action for AlertType.ShallowSoundingsWarning
export function viewSoundingOnChart(coords: [number, number]) {
    VesselPlanningModel!.dispatchEvent(
        new CustomEvent('view-shallow-sounding-on-map', { detail: { coords } }),
    )
}

// Slow Network - action on choosing slow network offline mode
export const confirmationToOfflineMode = async () => {
    const dialog = VoyageDialogPopupManager.createDialog({
        headerText: "Switch to Offline mode",
        bodyText: "Would you like to switch to offline mode?\nSome features may be unavailable. Selecting this option keeps you offline, \nand you will automatically return online once the connection stabilizes.",
        acceptButtonText: "Yes, I would",
        rejectButtonText: "Cancel"
    });
    
    const response = await dialog.getResponse();
    if (response === "accept") {
        // Implement offline mode logic here
        localStorage.setItem('isSlowNetworkOfflineMode', 'Yes');
            window.dispatchEvent(new CustomEvent('slowNetworkOffline', {
            detail: {
                timestamp: Date.now(),
                val: 'yes'
            }
        }));

    } else {
        localStorage.setItem('isSlowNetworkOfflineMode', 'No');
        window.dispatchEvent(new CustomEvent('slowNetworkOffline', {
            detail: {
                timestamp: Date.now(),
                val: 'no'
            }
        }));
    }
};